export default "__VITE_ASSET__DWdgIGRR__"